import { VFS, FileInfo } from '@/api/types'
import { parse } from 'fast-xml-parser'
import mime from 'mime'

export class Udxml implements VFS {
  private source: string
  constructor (source: string, config?: { [key: string]: string }) {
    this.source = source
  }

  async ResolveFilename (path: string): Promise<string> {
    console.log('Udxml.ResolveFilename', path)

    const pathParts = path.match(/[^/]+/g) || []
    if (pathParts.length !== 2) {
      throw new Error('not not file')
    }

    const documentID = decodeURIComponent(pathParts[0])
    const attachmentID = decodeURIComponent(pathParts[1])

    const opts: RequestInit = {
      method: 'GET'
    }

    const res = await this.fetch(this.source, opts)
    if (!res) {
      throw new Error('can\'t get content')
    }

    const xmlRoot = this.parseUdxml(res)
    const document = xmlRoot.find((d: any) => d.ID === documentID)
    if (!document) {
      throw new Error(`unable to resolve filename for ${path}`)
    }

    if (!Array.isArray(document.PRILOHY.item)) {
      document.PRILOHY.item = [document.PRILOHY.item]
    }

    const attachment: any = document.PRILOHY.item.find((att: any) => att.ID === attachmentID)
    return new URL(attachment.URL, this.source).href
  }

  async Stat (path: string): Promise<FileInfo> {
    // console.log('Udxml.Stat', path)

    const pathParts = path.match(/[^/]+/g) || []
    if (pathParts.length === 0) {
      return {
        Name: '',
        ContentType: '',
        IsDir: true
      }
    }

    const opts: RequestInit = { method: 'GET' }
    const res = await this.fetch(this.source, opts)
    if (!res) {
      throw new Error('can\'t get content')
    }

    const xmlRoot = this.parseUdxml(res)
    if (pathParts.length === 1) {
      const documentID = pathParts[0]
      const document = this.allDocuments(xmlRoot).find((f: FileInfo) => f.Name === documentID)
      if (!document) {
        throw new Error(`unable to Stat for ${path}`)
      }
      return document
    } else if (pathParts.length === 2) {
      const attachmentID = pathParts[1]
      const document = xmlRoot.find((d: any) => d.ID === pathParts[0])
      const attachment = this.getAttachments(document).find((f: FileInfo) => f.Name === attachmentID)
      if (!attachment) {
        throw new Error(`unable to Stat for ${path}`)
      }

      return attachment
    }

    throw Error(`${path} unable to Stat`)
  }

  private async fetch (input: RequestInfo, init?: RequestInit): Promise<string | undefined> {
    return fetch(input, init).then((res: Response) => {
      if (!window.caches) {
        return res.text()
      }
      return caches.open('udxml-cache').then((c: Cache) => {
        return c.put(input, res.clone()).then(() => {
          return res.text()
        })
      })
    }).catch(async () => {
      console.warn(`Error while fetching ${input}. Trying use cache`)
      const c = await caches.open('udxml-cache')
      const res = await c.match(input)
      return res?.text()
    })
  }

  private parseUdxml (text: string): any[] {
    let root = parse(text, {
      ignoreAttributes: false,
      ignoreNameSpace: true
    })

    root = Object.keys(root.ud.item).map((key) => ({ ID: root.ud.item[key]['@_id'], ...root.ud.item[key] }))
    if (!Array.isArray(root)) {
      return []
    }
    return root
  }

  private allDocuments (documents: any[]): FileInfo[] {
    return documents.reduce<FileInfo[]>((acc: FileInfo[], val: any): FileInfo[] => {
      const item: FileInfo = {
        Name: val.ID,
        IsDir: true,
        ContentType: '',
        XAttr: {
          DateFrom: val.VYVESENO,
          DateTo: val.STAZENO,
          Category: val.TYP,
          Name: val.NAZEV
        }
      }
      acc.push(item)
      return acc
    }, [])
  }

  private getAttachments (document: any): FileInfo[] {
    if (!document) {
      throw new Error('unable get files for TODO:')
    }
    // Po filtrovani vypadne jeden konkretni dokument
    if (!Array.isArray(document.PRILOHY.item)) {
      document.PRILOHY.item = [document.PRILOHY.item]
    }

    return Object.values(document.PRILOHY.item).reduce<FileInfo[]>((acc: FileInfo[], curr: any): FileInfo[] => {
      acc.push({
        Name: curr.ID,
        IsDir: false,
        ContentType: mime.getType(curr.URL) || 'application/octet-stream',
        XAttr: {
          Name: curr.NAME,
          DateFrom: document.VYVESENO,
          DateTo: document.STAZENO,
          Category: document.TYP,
          DocumentName: document.NAZEV
        }
      })
      return acc
    }, [])
  }

  async ReadDir (path: string): Promise<FileInfo[]> {
    // console.log('Udxml.ReadDir', path)

    const opts: RequestInit = {
      method: 'GET'
    }

    const res = await this.fetch(this.source, opts)
    if (!res) {
      throw new Error('can\'t get content')
    }

    const xmlRoot = this.parseUdxml(res)
    const pathParts = path.match(/[^/]+/g) || []
    if (pathParts.length === 0) {
      return this.allDocuments(xmlRoot)
    } else if (pathParts.length === 1) {
      const document = xmlRoot.find((d: any) => d.ID === pathParts[0])
      return this.getAttachments(document)
    }

    throw Error(`${path} unable to ReadDir`)
  }
}
